import React from "react";
import PropTypes from "prop-types";

import { alignments } from "core/props";

import { MaterialUIGridContainer } from "core/MaterialUI";
import BodyText from "core/BodyText";

import { GridItem, Image } from "./styles";

const IllustrativeHero = ({ sections, alignment }) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={9} // 48px spacing between elements
            tabletMaxPadding={4} // 20px spacing between elements
            desktopMinPadding={9} // 48px spacing between elements
            justify="center"
        >
            {sections.map((section, index) => (
                <GridItem item sm={12} md={4} lg={4} key={index}>
                    {!!section.image && (
                        <Image alignment={alignment}>{section.image}</Image>
                    )}

                    <BodyText type="div" size="xl" alignment={alignment}>
                        {section.text}
                    </BodyText>
                </GridItem>
            ))}
        </MaterialUIGridContainer>
    );
};

IllustrativeHero.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.any,
            text: PropTypes.any.isRequired
        })
    ),
    alignment: PropTypes.oneOf(alignments)
};

export default IllustrativeHero;
